import React from "react";

import { css, cx } from "@emotion/css";
import { QueryAwait } from "@steto-care/steto-query";

import { FontSizes } from "@/assets/fonts.ts";
import { Icons } from "@/assets/icons.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Queries } from "@/queries/Queries.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Dot } from "@/uiKit/atoms/Dot.tsx";
import { CenteredLoader } from "@/uiKit/atoms/Loader.tsx";
import { TooltipMenu } from "@/uiKit/atoms/TooltipMenu.tsx";
import { AlertsList } from "@/uiKit/molecules/PatientNavigation/AlertsList.tsx";

export type AlertsButtonProps = {
  patientId: string;
  className?: string;
};

export const AlertsButton: React.FC<AlertsButtonProps> = ({ patientId, className }) => {
  const styles = useStyles(makeStyles);
  const alerts = Queries.alerts.useListPatientAlerts(patientId);
  const countAlerts = alerts.length;

  return (
    <TooltipMenu
      id="manage-patient-alerts-button"
      className={cx(styles.container, className)}
      content={
        <QueryAwait
          pendingFallback={() => <CenteredLoader className={styles.loader} />}
          errorFallback={() => <CenteredLoader className={styles.loader} />}
        >
          <AlertsList patientId={patientId} />
        </QueryAwait>
      }
      placement="bottom-end"
    >
      <div className={styles.button}>
        {!!countAlerts && <Dot color="error" className={styles.dot} size="caption" />}
        <Icons.bell className={styles.icon} />
      </div>
    </TooltipMenu>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({}),
  loader: css({
    width: theme.spacing(128),
    height: theme.spacing(64),
  }),
  button: css({
    position: "relative",
    display: "flex",
    alignItems: "flex-end",
    alignSelf: "flex-end",
  }),
  dot: css({
    position: "absolute",
    top: theme.spacing(-1),
    right: theme.spacing(-1),
  }),
  icon: css({
    width: FontSizes.h6,
    height: FontSizes.h6,
  }),
});
